import { API } from './API';
import { getApiUrl } from '../utils/platform';

// Get companies with pagination and filtering
export const getCompanies = (query = {}) => {
  const { currentPage = 1, itemsPerPage = 20, sortBy = 'created_at', sortOrder = -1, keyword = '', is_seller, is_factory, is_shipping_agency, is_system } = query;
  
  let queryString = `currentPage=${currentPage}&itemsPerPage=${itemsPerPage}&sortBy=${sortBy}&sortOrder=${sortOrder}`;
  
  if (keyword) {
    queryString += `&keyword=${encodeURIComponent(keyword)}`;
  }
  
  if (is_seller !== undefined) {
    queryString += `&is_seller=${is_seller}`;
  }
  
  if (is_factory !== undefined) {
    queryString += `&is_factory=${is_factory}`;
  }
  
  if (is_shipping_agency !== undefined) {
    queryString += `&is_shipping_agency=${is_shipping_agency}`;
  }
  
  if (is_system !== undefined) {
    queryString += `&is_system=${is_system}`;
  }
  
  return API.get(`${getApiUrl()}/api/company?${queryString}`);
};

// Get company by ID
export const getCompanyByID = (id) => {
  return API.get(`${getApiUrl()}/api/company/${id}`);
};

// Get company by company_id
export const getCompanyByCompanyID = (company_id) => {
  return API.get(`${getApiUrl()}/api/company/company/${company_id}`);
};

// Create company
export const createCompany = (companyData) => {
  return API.post(`${getApiUrl()}/api/company`, companyData);
};

// Update company
export const updateCompany = (id, companyData) => {
  return API.put(`${getApiUrl()}/api/company/${id}`, companyData);
};

// Delete company (soft delete)
export const deleteCompany = (id) => {
  return API.delete(`${getApiUrl()}/api/company/${id}`);
};

// Get public company info by shortcode (no auth required)
export const getPublicCompanyByShortcode = (shortcode) => {
  return API.get(`${getApiUrl()}/api/company/public/shortcode/${shortcode}`);
};

const companyService = {
  getCompanies,
  getCompanyByID,
  getCompanyByCompanyID,
  createCompany,
  updateCompany,
  deleteCompany
};

export default companyService;
